import { ActionButton as ActionButton2 } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { useUploadImage } from 'libs/hooks/io/useUploadImage';
import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import { useContext, useEffect } from 'react';
import { CtxDetail } from 'session/ctxDetail';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const HeaderImageSelection = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);
    const { inProgress, uploaded, setFiles } = useUploadImage(
        [EUploadResolution.LARGE],
        ctxDetail.map?.worldMapId
    );

    useEffect(() => {
        if (uploaded) {
            console.log('Uploaded', uploaded?.data?.imageUrls[EUploadResolution.LARGE]);
            ctxDetail.changeDetailInput(
                {
                    ...ctxDetail.updateDetailInput,
                    detailInput: {
                        ...ctxDetail.updateDetailInput.detailInput,
                        header: {
                            ...ctxDetail.updateDetailInput.detailInput.header,
                            imageUrl: uploaded?.data?.imageUrls[EUploadResolution.LARGE]
                        }
                    }
                },
                { triggerHistory: true, saveImmediately: true }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploaded]);

    return (
        <S_HeaderImageSelection2 className={props.className}>
            <S_Image2 $src={ctxDetail.updateDetailInput.detailInput.header.imageUrl} />
            <S_Options>
                {ctxDetail.updatingIndex === -1 && (
                    <>
                        {ctxDetail.updateDetailInput.detailInput.header.imageUrl && (
                            <S_Remove
                                icon={{ iconName: 'xmark' }}
                                disabled={inProgress !== 0}
                                onClick={() => {
                                    ctxDetail.changeDetailInput(
                                        {
                                            ...ctxDetail.updateDetailInput,
                                            detailInput: {
                                                ...ctxDetail.updateDetailInput.detailInput,
                                                header: {
                                                    ...ctxDetail.updateDetailInput.detailInput
                                                        .header,
                                                    imageUrl: null
                                                }
                                            }
                                        },
                                        { triggerHistory: true, saveImmediately: true }
                                    );
                                }}
                            />
                        )}
                        <>
                            <label>
                                {inProgress === 0 && (
                                    <S_InputFile
                                        type="file"
                                        accept="image/x-png,image/png,image/gif,image/jpeg,image/jpg,image/heic,image/heif,image/svg+xml,.heic;capture=camera"
                                        onChange={(e) => setFiles(Array.from(e.target['files']))}
                                    />
                                )}
                                <ActionButton2
                                    text={
                                        inProgress === 0
                                            ? Localization.SELECT_ACTION
                                            : Localization.UPLOADING
                                    }
                                    icon={{ iconName: 'upload' }}
                                    disabled={inProgress !== 0}
                                />
                            </label>
                        </>
                    </>
                )}
            </S_Options>
        </S_HeaderImageSelection2>
    );
};

const S_InputFile = styled.input`
    display: none;
`;

const S_HeaderImageSelection2 = styled.div`
    display: flex;
    justify-content: space-between;
`;

const S_Image2 = styled.div<{ $src: string }>`
    width: 40px;
    height: 40px;
    border-radius: 7px;
    background-image: url(${(props) => props.$src});
    background-size: cover;
    background-position: center;
    border: 1px solid #dadada;
    margin: 0 15px 0 0;
`;

const S_Options = styled.div`
    display: flex;
`;

const S_Remove = styled(ActionButton2)`
    margin: 0 15px 0 0;
`;
